<script>
  import CaseStudy from "./CaseStudy.svelte";

  let title = "GMGT Live";
  let headerLine =
    "Code World Solutions delivers a stunning and performant user experience on desktop and mobile";
  let tagLine = "";
  let productUrl = "https://gmgt.live";
  let headerImage = {
    src: "/images/gmgt-logo-blue.jpg",
    width: 512,
    height: 512
  };
</script>

<style>
  ul {
    display: inline-block;
    text-align: left;
  }
  .list {
    text-align: center;
  }
  .page-header {
    height: 20vh !important;
  }
</style>

<svelte:head>
  <title>{title} Case Study - CodeWorld</title>
</svelte:head>

<div
  class="page-header header-filter blue-filter"
  data-parallax="true"
  style="background-image: url('/assets/img/web.jpg')" />
<div class="container">
  <div class="section text-center">
    <div class="card card-body">
      <h1>{title}</h1>
      <h2>{headerLine}</h2>
      <div>
        <a href="https://apps.apple.com/us/app/gmgt-live/id1552819269">
          <img
            src="/images/image_from_ios.jpg"
            alt="iOS sign in screen"
            class="h-96 mx-auto" />
        </a>
        <img
          src="/images/hqdefault.jpg"
          alt="GMGT employees during a show"
          class="h-96 mx-auto" />
        <i>{tagLine}</i>
      </div>
      <div>
        <h5>
          Based out of New York,
          <b>GMGT</b>
          is the place for all things Caribbean. They wanted a website built to
          improve their web presence.
        </h5>

        <h5>
          CWS designed, developed, and delivered a customized web app experience
          complete with an audio player, log-in functionality, a content
          management system, a store, and much more. By working from the ground
          up, we are able to cater to our client's vision down to the last
          detail.
        </h5>
        <br />
        <h5>
          Not only that, but with our analytics we were able to see that the
          majority of their users listened with iPhones. With this information
          we were able to pitch and build an iOS to delight their customers even
          more.
        </h5>

        <h2>Web development</h2>

        <a href={productUrl}>
          <img
            width={headerImage.width}
            height={headerImage.height}
            src={headerImage.src}
            class="mx-auto d-block"
            alt="The {title} case study product" />
          {productUrl}
        </a>

        <h2>iOS app development</h2>

        <p>
          Featuring live audio streaming and schedules to see the shows straight
          from the app
        </p>

        <a href="https://apps.apple.com/us/app/gmgt-live/id1552819269">
          <p>Check it out on the AppleStore</p>
        </a>

        <img
          src="/images/mockup-for-a-podcast-featuring-an-iphone-x-in-a-co-working-space-24718.jpg"
          alt="co-working space"
          class="w-96 mx-auto" />
        <div />

        <div class="grid grid-cols-3 gap-1 mx-auto content-center w-96">
          <img
            src="/images/appstore-screenshot-maker-of-an-angled-space-gray-iphone-x-a17412.jpg"
            alt="schedule feature in app"
            class="h-96" />
          <img
            src="/images/appstore-screenshot-maker-of-an-angled-space-gray-iphone-x-a17412-2.jpg"
            alt="app home screen"
            class="h-96" />
          <img
            src="/images/appstore-screenshot-maker-of-an-angled-space-gray-iphone-x-a17412-3.jpg"
            alt="schedule featuring the Jam"
            class="h-96" />
        </div>
        <h5 class="info-title">The CWS competitive advantage</h5>

        <div class="list">
          <ul class="list-group">
            <li class="list-group-item">
              Blazing fast websites and mobile apps. Tested with 3G networks and
              up!
            </li>
            <li class="list-group-item">
              Great user experiences on multiple devices.
            </li>
            <li class="list-group-item">Increased presence with SEO.</li>
            <li class="list-group-item">
              Integrated CMS with real time previews for enhanced content
              writing.
            </li>
          </ul>
        </div>

        <div>
          <i class="material-icons">group_work</i>
          <h5>
            As a result of working with Code World Solutions, GMGT has seen
            steadily increased user growth on multiple platforms.
          </h5>
        </div>

      </div>
      <div class="progress">
        <div
          class="progress-bar bg-danger"
          role="progressbar"
          style="width: 100%"
          aria-valuenow="100"
          aria-valuemin="0"
          aria-valuemax="100" />
      </div>
      <div>
        <div>
          <h4 class="info-title">Collaborate</h4>
          <h5>
            Working with CWS provides you access to a world class development
            team without the cost of maintaining your own. The team is available
            when you're ready.
          </h5>
          <h4>Interested?</h4>
          <a href="/contact">Contact us.</a>
        </div>
      </div>
    </div>
  </div>
</div>
